<template>
  <div id="app">
    <h2>智能客服管理系统</h2>
    <div class="container">
      <el-input
        v-model="name"
        placeholder="请输入用户名"
        style="width: 50%"
      ></el-input>
      <el-input
        show-password
        v-model="password"
        placeholder="请输入密码"
        style="width: 50%;margin-top: 1.25rem;"
      ></el-input>
      <el-button
        type="primary"
        style="width: 30%;margin-top: 1.875rem;"
        @click="login"
        >登录</el-button
      >
    </div>

	<div class="filings">
      &copy;2020-2023 {{ copyrightURL }} 版权所有 ICP证：<a
        href="https://beian.miit.gov.cn/"
        target="_blank"
      >
        {{ filingName }}</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      name: "",
      password: "",
	  copyrightURL:"",
	  filingName:""
    };
  },
  mounted() {
	this.getDomainName()
  },	
  methods: {
    // 获取URL一级域名
    getDomainName() {
      const online = "苏ICP备2020058729号-3";
      const cc = "苏ICP备2020058729号-2";
      const url = window.location.hostname
        .split(".")
        .slice(-2)
        .join(".");
      this.copyrightURL = "苏州贝果智能科技有限公司";
      if (url === "medibot.cc") {
        this.filingName = cc;
      } else if (url === "medibot.online") {
        this.filingName = online;
      } else if (url === "localhost") {
        this.filingName = "测试网址";
      }
    },
    login() {
      console.log("app login action");

      this.lginRequest();
    },

    async lginRequest() {
      var api = "/projectchat/user/pass/login";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          loginName: this.name,
          password: this.password,
        },
      });
      console.log("login login response = ", response);

      if (response.resultCode === "10000") {
        localStorage.setItem("projectToken", response.data.token);

        this.$router.replace({
          path: "/home",
        });
      } else {
        this.$message.error(response.desc);
      }
    },
  },
};
</script>

<style scoped="scoped">
.container {
  width: 60%;
  height: 18.75rem;
  background: #ffffff;
  box-shadow: 0px 0px 7px 5px rgba(230, 230, 230, 0.5);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  margin-top: 1.875rem;
}

.filings {
    position: fixed;
    bottom: 20px;
	left: 50%;

	transform: translateX(-50%);
    color: #666;
	text-align: center;
	z-index: 1000000;
    a {
      color: inherit;
      &:hover {
        color: #000;
      }
    }
  }
</style>
